<template>
  <div
    v-if="verificationStatus.isVerificationRequired"
    class="message"
  >
    <div
      v-if="isLoading"
      class="loader loader--medium"
    />

    <template v-else>
      <!-- Resend verification link via SMS -->
      <div
        v-if="verificationStatus.isPhoneRequired "
        class="layout layout--icon layout--icon-extra-spacing"
      >
        <span class="icon icon--bigger far fa-phone gray" />

        <p class="smaller">
          {{ customPhoneVerificationMessage }}
          <button
            class="link primary"
            type="button"
            @click="resendSmsPasscodeClickHandler"
          >
            Resend Verification SMS
          </button>
        </p>
      </div>

      <!-- Resend verification link via Email -->
      <div
        v-if="verificationStatus.isEmailRequired"
        class="layout layout--icon layout--icon-extra-spacing"
      >
        <span class="icon icon--bigger far fa-envelope gray" />

        <p class="smaller">
          {{ customEmailVerificationMessage }}
          <button
            class="link primary"
            type="button"
            @click="resendEmailVerificationClickHandler"
          >
            Resend Verification Email
          </button>
        </p>
      </div>
    </template>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'VerifyAccountCta',

    props: {
      customPhoneVerificationMessage: {
        type: String,
        default: 'Please verify your phone number to complete your account registration.'
      },

      customEmailVerificationMessage: {
        type: String,
        default: 'Please verify your email address to complete your account registration'
      }
    },

    data() {
      return {
        isLoading: false
      };
    },

    computed: {
      ...mapGetters('session', ['currentUser']),
      ...mapGetters('merchant', ['merchant']),

      verificationStatus() {
        const { isPhoneRequired, isEmailRequired, isVerificationRequired } = this.currentUser.accountVerificationStatus;

        return {
          isPhoneRequired,
          isEmailRequired,
          isVerificationRequired
        };
      }
    },

    methods: {
      async resendSmsPasscodeClickHandler() {
        this.isLoading = true;

        const payload = { contactInfo: this.currentUser.primarySmsNumber, contactType: 'phoneNumber' };

        const { isSuccess } = await this.$store.dispatch('session/resendTwoFactorAuthPasscode', payload);

        if (isSuccess) {
          const twoFactorAuthModalPayload = { ...payload, authType: 'phone-number-verification-required' };

          this.$openModal('twoFactorAuthModal', twoFactorAuthModalPayload);

          // this.$triggerGoogleTrackingEvent('ResendSMSVerification', 'Account');

          this.$triggerNewRelicEvent('ResendSMSVerification', 'Information', 'Resend SMS Verification');
        }

        this.isLoading = false;
      },

      async resendEmailVerificationClickHandler() {
        this.isLoading = true;

        await this.$store.dispatch('session/resendVerificationEmail');

        // this.$triggerGoogleTrackingEvent('ResendEmailVerification', 'Account');

        this.$triggerNewRelicEvent('ResendEmailVerification', 'Information', 'Resend Email Verification');

        this.isLoading = false;
      }
    }
  };
</script>
